import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "../components/Header";
import FooterComp from "../components/FooterComp";
import { CheckoutPanel } from "./CheckoutPanel";

const CheckOut = () => {
  const { id } = useParams();
  const history = useHistory();
  const token = localStorage.getItem(`${process.env.REACT_APP_TOKEN}_user`);

  React.useEffect(() => {
    if (!token) {
      const returnTo = `/checkout/${id}`;
      history.replace(
        `/user/signup?returnTo=${encodeURIComponent(returnTo)}`,
      );
    }
  }, [history, id, token]);

  if (!token) return null;

  return (
    <Box
      onContextMenu={(event) => event.stopPropagation()}
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Header />
      <Box sx={{ height: { xs: 56, md: 64 } }} />

      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          p: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <CheckoutPanel planId={id} maxWidth={480} />
      </Box>

      <FooterComp />
    </Box>
  );
};

export default CheckOut;
